import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installNativeXR } from './nativeXR';
import './styles/index.css';

// navigator.xr must exist before the viewer checks for AR support.
void installNativeXR()
    .catch(error => { console.warn('[nativeXR] install failed; AR is unavailable.', error); })
    .finally(() => createRoot(document.getElementById('root')!).render(<App />));
